import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import DatePicker from "react-datepicker";
import filterFactory, { textFilter, numberFilter, FILTER_TYPES } from "react-bootstrap-table2-filter";

//import ExifOrientationImg from 'react-exif-orientation-img'
//import ReactImageMagnify from 'react-image-magnify';
import Modal from 'react-responsive-modal';

import {SERVER_URL, LOCAL_URL, PAPER_SIZE_LETTER, PAPER_SIZE_LABEL, PAPER_SIZE_LABEL_2BY4}  from '../Constants';
import LostItemDetailViewer from './LostItemDetailViewer';
import Select from 'react-select'
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import Cookies from 'universal-cookie';
import CheckInTransfer from '../Warehouse/CheckInTransfer';
import ReactImageMagnify from 'react-image-magnify';
//import  { dateFilter, selectFilter, Comparator, numberFilter } from 'react-bootstrap-table2-filter';
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css"
import ViewToggle from './ViewComponents/viewtoggle'
import GalleryView from './ViewComponents/gallery'
//import TableView from './ViewComponents/table'
import DockView from './ViewComponents/dock'

const { SearchBar } = Search;

const cookies = new Cookies();


const paginationOption = {
  custom: true,
  sizePerPage: 200
};

const CELL_FONT_SIZE = '12px'



// options as Object
//const selectOptions = {
//  true: 'Yes',
//  false: 'No'
//};




const defaultSorted = [{
  dataField: 'foundDate',
  order: 'asc'
}];



function afterFilter(newResult, newFilters) {
  console.log(newResult);
  console.log(newFilters);
}

function formatItemStatusCell(cell,row){
  let statusText= LostItemFunctions.itemStatusDesc(row.itemState);
  if (row.itemState==='C' || row.itemState==='R'){
      return(<p className="text-success"><b>{statusText}</b></p>);
  }else if(row.itemState==='Q'){
      return(<p className="text-info"><b>{statusText}</b></p>);
  }else{
      return(<p className="text-primary"><b>{statusText}</b></p>);
  }
};




/*function formatKeyword(cell,row){
  if (cell){
    return (cell.length >50) ? cell.substr(0, 50) + '...' : cell;
  }
}

function magnifyImage(cell, row){
  
  if (row.url){
    return (
      <ReactImageMagnify {...{
        smallImage: {
            alt: row.shortDescription,
            isFluidWidth: true,
            src: row.url
        },
        largeImage: {
            src: row.url,
            width: 1200,
            height: 1800
        }
    }} />

    )
  }else{
    return (
      <img  src='../default-placeholder.png' width={50} alt={row.shortDescription} />
      )
  }
  
}*/


function imageFormat(cell, row){
    
    if (row.url){
     
      return (
       
         // <img  src={PARSE_SERVER_FILES_URI  + cell} width={75} height={65} alt={row.shortDescription} style={{cursor:'zoom-in'}} />
           <img  src={row.url} width={75} height={65} alt={row.shortDescription} style={{cursor:'zoom-in'}} />
      
      );
    }else{
      return (
        <img  src='../default-placeholder.png' width={75} alt={row.shortDescription} />
    )
    }
}

const headerStyle = {
  position: 'sticky', // Key for sticky header
  top: 0,              // Stick to the top
  backgroundColor: '#fff', // Ensure background is visible
  zIndex: 1 // Ensure the header is above the scrolling content
};

const containerStyle = {
  height: '400px',
  overflowY: 'auto',
  overflowX: 'auto'
};

class LostItems extends Component {

  constructor(props) {
    super(props);
    
    
    let initialLostItemFilterCookie= cookies.get('initialLostItemFilter');
    let displayViewType = cookies.get('displayViewType');

    //*****TEMP */
    //displayViewType = 'table';
    //console.log('Initial Cookie For Filter: ' + initialLostItemFilterCookie); 
    let defaultFilter = ''; //let defaultFilter = 'Q';
    if (this.props.match.params.filter!==undefined){
      // use this if being called from another page and forcing the filter, i.e. Dashboard links
      defaultFilter = this.props.match.params.filter;
    }else if (initialLostItemFilterCookie!==undefined){
      // Carfeful!  This can be valid as "" signifying load all items.  only check for undefined.
      defaultFilter = initialLostItemFilterCookie;
    }


    this.state = {
      questions: null,
      showCards: false,
      lostItems:[],
      filteredItems:[],
      filteredStatus:'',
     
      otherCount:0,
      queueCount:0,
      claimCount:0,
      publishCount:0,
      allCount:0,
      returnCount:0,
      dispossedCount:0,
      donatedCount:0,
      itemStateFilter: defaultFilter,
      venueTypeCd: '',
      enableWarehouse: false,
      venueSubscriptions: [],
      displayVenueSubscriptions: false,
      selectedSubscriptionFilters: [],
      displayDetailModal:false,
      displayQueryLayout: true,
      queryParams : {},
      refreshButtonText: 'Refresh',
      selectedRows:[],
      actionButtonDisabled : true,
      actionItemsSelected : 0,
      selectedFilterLabel:'ALL',
      checkedCount: 0,
      displayDonateDisposeModal:false,
      donateDisposeNote:'',
      donateDisposeDate:undefined,
      displayLargeImageModal: false,
      selectedImageUrl:'',
      isGreenflag:false,
      displayCheckInTransfer: false,
      checkInTransferMode:1,
      checkInLocations:[],
      checkInLocationFilter : '',
      dispositionVendors:[],
      dispositionVendorId:'',
      filterText:'',
      useColumnFilters:(cookies.get('useColumnFilters')==='true') ? true : false,
      displayReturnToStaff:false,
      returnToStaffName:'',
      statusFilter:'',
      displayViewType:(displayViewType) ? displayViewType : 'table',
      displayBatchPrintInventoryLabels:false
    };

    cookies.set('initialLostItemFilter', this.state.itemStateFilter, { path: '/' });
    this.tableRef = React.createRef();

    this.rowEvents = {
      onClick: (e, row, rowIndex) => {
        //console.log('venue ID' + auth0Client.getActiveVenuedId() + 'row venue:' + row.venueId);
       
        /*this.setState({
          actionButtonDisabled : (this.state.selectedRows.length===0),
          actionItemsSelected: this.state.selectedRows.length
        })
        */
        // If this was the checkbox, then ignore
        //console.log(e.target);
        // Check of this element is a TD containing a checkbox
        if (e.target.hasChildNodes()){
          if (e.target.childNodes[0].type==='checkbox'){
            //console.log('ignore');
            return;
          }
        }
        if (e.target.type==='checkbox') {return;}
        if (e.target.tagName.toLowerCase() === 'img'){return;}
        /*if (e.target.tagName.toLowerCase() === 'img'){
          e.stopPropagation(); //dont check
          this.setState({
            selectedImageUrl : e.target.src,
            displayLargeImageModal:true});
           
          return;
        }*/

        this.setState({
          lostItem: row,
          displayDetailModal:(auth0Client.getActiveVenuedId()!==row.venueId )
        })
        //this.props.history.push('/LostItem/' + row.id);
        if (auth0Client.getActiveVenuedId()===row.venueId){
          this.props.history.push('/LostItem/' + row.id);
        }
        //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
        
    
      },
      
    };

    axios.interceptors.response.use(response => {
      return response;
    }, error => {
     if (error.response.status === 401) {
      ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
      
     }
    

     return error;
    });
    
    

  }

  handleRowCheckChange=(e)=>{
  
    this.setState({
      checkedItem: e.target.id
    });
    console.log(e.target.id + ':' + e.target.checked);
  }

  onCloseDetailModal=()=>{
    this.setState(
      {
        displayDetailModal : false
      }
    )
  }

  showOpenDetail=()=>{

  }


  filterChanged = (queryParams) =>{
    this.setState({
      queryParams : queryParams
    })
    this.queryLostItems(queryParams);
  }


  loadVenueSubScription=()=>{
    try{

    
      //  console.log('loading...' + auth0Client.getIdToken());
      axios.get(SERVER_URL +  '/venue/VenueSubscriptions/',{
        headers: { 
          'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId': auth0Client.getActiveVenuedId() 
        }
      }).then((res)=>{
        const venuSubscriptionsArray = (res.data) ? res.data : [];
        var options = [];
        venuSubscriptionsArray.map((item)=>{
          options.push({
            label: item.subscriptionVenueAlias,
            value: item.subscriptionVenueId,
          });
          return item;
        })
        
        


        this.setState({
          venueSubscriptions: options,
          selectedSubscriptionFilters:options,
          displayVenueSubscriptions: (options.length >0)
        })
      }

      );
    }catch(e){

      ToastStore.error("An error occured. Please try again. Error:" + e.message);
    }

  }


  // Chang in this should add another filter to the filtered results
  handleInputStorageChange=(event) =>{
    const target = event.target;
    const value = target.value;
   
    //const name = target.name;

    this.setState({
      checkInLocationFilter : value,
     
    }, ()=>{
      this.applyAllFilters()
    });
  }

 // Loads the check in locations for the storage selection list.  Warehouse accounts
  // can only select from a specific list.
  loadCheckInLocationsForStorage=async()=>{

    try{
        const checkInLocations = (await axios.post(`${SERVER_URL}/CheckInOut/CheckInLocations`,{}, {
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
        this.setState({checkInLocations:checkInLocations})

    }catch(e){
      this.setState({checkInLocations:[]})
    }
      
  }

queryLostItems=(queryParams)=>{

   //  console.log('loading...' + auth0Client.getIdToken());
   axios.post(SERVER_URL +  '/LostItems/Query',{
    queryParams:queryParams,

   }, {

   
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId() 
    }
  }).then((res)=>{
    
    if (res.status === 401) {
      //place your reentry code
      console.log("Error" + res.status);
     
     }


    const lostItems = res.data;
    //let filteredItems = lostItems;
    /*if (this.state.initialFilter){
      filteredItems = lostItems.filter((lostItem) =>{
        if (lostItem.itemState === this.state.initialFilter){
            return lostItem;
          }else{
            return null;
          }
        });
        
    }*/

    if (lostItems){
      var openTotal = lostItems.filter(l => l.itemState === 'Q').length;
      this.setState({
        lostItems: lostItems,
        //filteredItems : filteredItems,  // dont set this here, its being set below in apply.  
        queueCount:openTotal,
        claimCount:lostItems.filter(l => l.itemState === 'C').length,
        otherCount:lostItems.filter(l => l.itemState === 'A').length,
        dispossedCount:lostItems.filter(l => l.itemState === 'T').length,
        donatedCount:lostItems.filter(l => l.itemState === 'D').length,
        returnCount:lostItems.filter(l => l.itemState === 'R').length,
        allCount:lostItems.length,
        });
        if (this.props.updateOpenLostItems) { this.props.updateOpenLostItems(openTotal);}
    }

    // Apply any initial filters from the params or defaults
    //console.log('initial filter' + this.state.itemStateFilter);
    //this.applyFilter(this.state.itemStateFilter);
    this.applyAllFilters();

    }).catch((e)=>{ 
      //console.log("error " + e)
      ToastStore.error("An error occured. Please try again :" + e.message);
    });


  }

  cleanSelectedCheckboxes=()=>{
  //The table is using the selected items array with 
  // in this state object and the key field to determine what is selected
  this.setState({selectedRows: []});
 
}
ageInDays=(foundDate)=>{
  try {
    if(foundDate){
      const today = new Date();
      var res = Math.abs(today - new Date(foundDate)) / 1000;

      var days = Math.floor(res / 86400);
      return days;
    }
  } catch(e){
      return '';
  }
  
}
loadDispositionVendors=async()=>{

  try{
      const resultsDTO = (
        await axios.get(`${SERVER_URL}/dispo/vendors`,{
              headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }
            })).data;
      if (resultsDTO.items){
        this.setState({dispositionVendors:resultsDTO.items})
      }
      
      

  }catch(e){
    this.setState({dispositionVendors:[]})
  }
    
}
loadLostItemsNew=()=>{
    
   
  
 // console.log('loading...' + this.state.itemStateFilter);
  this.setState({refreshButtonText:'Loading...'});
  this.cleanSelectedCheckboxes();

  //if (this.ref.table) {  this.refs.table.cleanSelected();}
  axios.post(SERVER_URL +  '/LostItems/founditemquery',{
        itemsStates:['Q']
    },
    {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId(),
     
    }
  }

  ).then((res)=>{
    
    if (res.status === 401) {
      //place your reentry code
      console.log("Error" + res.status);
     
     }


    const lostItems = res.data;
    let filteredItems = lostItems;
    /*if (this.state.initialFilter){
      filteredItems = lostItems.filter((lostItem) =>{
        if (lostItem.itemState === this.state.initialFilter){
            return lostItem;
          }else{
            return null;
          }
        });
    }*/

    if (lostItems){
      //let selectedFilterLabel = LostItemFunctions.itemStatusDesc(this.state.initialFilter) + ' (' + lostItems.filter(l => l.itemState ===this.state.initialFilter).length + ')';
      // add age to the data
      for (var i=0; i<lostItems.length; i++){
        lostItems[i].age =this.ageInDays(lostItems[i].foundDate);
      };

      var openTotal = lostItems.filter(l => l.itemState === 'Q').length;
      this.setState({
        lostItems: lostItems,
        filteredItems : filteredItems,
        queueCount:openTotal,
        claimCount:lostItems.filter(l => l.itemState === 'C').length,
        otherCount:lostItems.filter(l => l.itemState === 'A').length,
        dispossedCount:lostItems.filter(l => l.itemState === 'T').length,
        donatedCount:lostItems.filter(l => l.itemState === 'D').length,
        returnCount:lostItems.filter(l => l.itemState === 'R').length,
        allCount:lostItems.length,
        //selectedFilterLabel: selectedFilterLabel,
        });
        if (this.props.updateOpenLostItems) { this.props.updateOpenLostItems(openTotal);}
        this.setState({refreshButtonText:'Refresh'});
    }
    // Apply any initial filters from the params or defaults
  //console.log('initial filter' + this.state.initialFilter);
  //this.applyFilter(this.state.itemStateFilter);
  this.applyAllFilters();

    }).catch((e)=>{ 
      //console.log("error " + e)
      this.setState({refreshButtonText:'Refresh'});
      ToastStore.error("An error occured. Please try again");
    });
}


loadLostItems=()=>{
    
   
  
    //console.log('loading...' + this.state.initialFilter);
    this.setState({refreshButtonText:'Loading...'});
    this.cleanSelectedCheckboxes();

    //if (this.ref.table) {  this.refs.table.cleanSelected();}
    axios.get(SERVER_URL +  '/LostItems',{
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId() 
      }
    }).then((res)=>{
      
      if (res.status === 401) {
        //place your reentry code
        console.log("Error" + res.status);
       
       }


      const lostItems = res.data;
      let filteredItems = lostItems;
      /*if (this.state.initialFilter){
        filteredItems = lostItems.filter((lostItem) =>{
          if (lostItem.itemState === this.state.initialFilter){
              return lostItem;
            }else{
              return null;
            }
          });
      }*/

      if (lostItems){
        //let selectedFilterLabel = LostItemFunctions.itemStatusDesc(this.state.initialFilter) + ' (' + lostItems.filter(l => l.itemState ===this.state.initialFilter).length + ')';
        // add age to the data
        for (var i=0; i<lostItems.length; i++){
          lostItems[i].age =this.ageInDays(lostItems[i].foundDate);
        };

        var openTotal = lostItems.filter(l => l.itemState === 'Q').length;
        this.setState({
          lostItems: lostItems,
          filteredItems : filteredItems,
          queueCount:openTotal,
          claimCount:lostItems.filter(l => l.itemState === 'C').length,
          otherCount:lostItems.filter(l => l.itemState === 'A').length,
          dispossedCount:lostItems.filter(l => l.itemState === 'T').length,
          donatedCount:lostItems.filter(l => l.itemState === 'D').length,
          returnCount:lostItems.filter(l => l.itemState === 'R').length,
          allCount:lostItems.length,
          //selectedFilterLabel: selectedFilterLabel,
          });
          if (this.props.updateOpenLostItems) { this.props.updateOpenLostItems(openTotal);}
          this.setState({refreshButtonText:'Refresh'});
      }
      // Apply any initial filters from the params or defaults
    //console.log('initial filter' + this.state.initialFilter);
    //this.applyFilter(this.state.itemStateFilter);
    this.applyAllFilters();

      }).catch((e)=>{ 
        //console.log("error " + e)
        this.setState({refreshButtonText:'Refresh'});
        ToastStore.error("An error occured. Please try again");
      });
}

  async componentDidMount() {
    try {
      let venue=  auth0Client.getDefaultVenue();
         
      // set venueTypeCode
      this.setState({
        venueTypeCd: venue.venueTypeCd,
        enableWarehouse:venue.enableWarehouse,
        displayQueryLayout: false,//(venueTypeCd==='A'),
      })
    
      this.loadCheckInLocationsForStorage();
      //this.loadVenueSubScription();
      this.loadLostItems();
      this.loadDispositionVendors();
      }
        catch(e){
          ToastStore.error(e.message);
        }
    

    
 
  }


  // Implement startWith instead of contain 
  customMatchFunc=(searchText,value,column,row)=> {
    if (typeof value !== 'undefined') {
      console.log(searchText)
      return value.startsWith(searchText);
    }
    return false;
  }

    handleSubscriptionFilterChange=async(items) =>{

      //console.log(this.state.selectedSubscriptionFilters);
      await this.setState({
        selectedSubscriptionFilters: items
      });

      this.loadLostItemsSubscription();
    }

    onCheckInTransferCompleted=(itemsUpdated)=>{
          // Reload everything
          // change the slected index of action dropdown
          this.setState({displayCheckInTransfer:false})  
        this.loadLostItems();

    }
  renderCheckInTransfer =()=>{

    return(
      <Modal style={{width:250, height:250}} open={this.state.displayCheckInTransfer} onClose={()=>this.setState({displayCheckInTransfer:false})} center>
                <CheckInTransfer selectedItems={this.state.selectedRows} mode={this.state.checkInTransferMode}  
                                onCheckInTransferCompleted={this.onCheckInTransferCompleted.bind(this)} 
                                onClose={()=>this.setState({displayCheckInTransfer:false})} 
                                >
                                
                </CheckInTransfer>
      </Modal>
    )


  }

  batchPrint=(layout)=>{
    //console.log('batch print');
    this.setState({displayBatchPrintInventoryLabels:false});
    let items = this.state.selectedRows;
   
    // open a new window with the print layout and pass the ids
    let url = LOCAL_URL + '/LostItem/BatchPrintInventory/layout=' + layout + '&ids=' + items.join(',') + '&tid=' + auth0Client.getIdToken() + '&vid=' + auth0Client.getActiveVenuedId();;
    window.open(url, '_blank', 'menubar=1,toolbar=1, location=0');
  }

  renderBatchProcessInventoryLabels=()=>{
    return(
      <Modal  open={this.state.displayBatchPrintInventoryLabels} onClose={()=>this.setState({displayBatchPrintInventoryLabels:false})} center>
             <div className="flex justify-between items-center">
             <div className="row" style={{width:525, height:100, alignItems:'center', justifyContent:'center'}}>
                <div className="col-12" text-center><h5>Select format for printing inventory labels</h5></div>
                <hr/>
                </div>
                <div className='row'>
                <div className='col-12 text-center' style={{marginTop:10, flex:1, alignItems:'center', justifyContent:'center'}}>
                  <button className='btn btn-outline-info' onClick={()=>{this.batchPrint(PAPER_SIZE_LETTER)}}>Layout: Letter (8.5 X 11)</button>
                  <button className='btn btn-outline-primary' onClick={()=>{this.batchPrint(PAPER_SIZE_LABEL)}}>Layout: Label (4 X 6)</button>
                  <button className='btn btn-outline-primary' onClick={()=>{this.batchPrint(PAPER_SIZE_LABEL_2BY4)}}>Layout: Label (2 1/8 X 4)</button>
                 
                </div>
            </div>
            </div>  
      </Modal>
    )
  }
  renderDisposeDonateDetailsModal=()=>{
    return (
      <Modal open={this.state.displayDonateDisposeModal} onClose={()=>this.setState({displayDonateDisposeModal:false})} center>
          <div style={{width:'500px', height:'500px'}}>
            <h5>Donation and Disposal Batch Upate:</h5>
            <small>Each record will be assigned the following date and note:</small>
            <br/><br/>
            <label htmlFor="donateDisposeDate" className='text-danger'><b>Date:</b></label>
                                <br/>
                                  <DatePicker
                                  className="form-control"
                                    onChange={this.onReturnedDonateDisposeDateChanged}
                                    name="donateDisposeDate"
                                    selected={this.state.donateDisposeDate}
                                  />             
                              
                <br/>         
            <label htmlFor="donateDisposeNote" className='text-primary'><b>Donate/Dispose Note:</b></label>
                          <input
                                              disabled={this.state.disabled}
                                              type="text"
                                              onChange={this.handleInputChange}
                                              name="donateDisposeNote"
                                              className="form-control"
                                              placeholder=""
                                              value= {this.state.donateDisposeNote}
                                            />
              <br/>
              
              <label htmlFor="dispositionVendorId" className='text-primary'> Vendor:</label>
            

              
            <select 
                 className="custom-select"
                 type="text"
                 name="dispositionVendorId"
                 onChange={this.handleInputChange}
                 value={this.state.dispositionVendorId}
             >   
               <option value=""></option>
                 {this.state.dispositionVendors.map(item=>{
                     return (
                         <option value={item._id} key={item._id}>{ item.vendorName }</option>
                     )
                 })}
            </select>
              


          </div>
          <button
            disabled={this.state.disabled}
            className="btn btn-success"
            onClick={() => {this.batchUpdateDontateDisposed()}}>
                Run Batch Update
          </button>
    </Modal>  
    )
  }

  renderReturnToStaff =()=>{

      return(
        <Modal open={this.state.displayReturnToStaff} onClose={()=>this.setState({displayReturnToStaff:false})} center>
        <div style={{width:'500px', height:'500px'}}>
          <h5>Return To Staff:</h5>
          <small>Each record will be assigned the following:</small>
          <br/><br/>
          <label htmlFor="donateDisposeDate" className='text-danger'><b>Date:</b></label>
                              <br/>
                                <DatePicker
                                autoComplete="off"
                                className="form-control"
                                  onChange={this.onReturnedDonateDisposeDateChanged}
                                  name="donateDisposeDate"
                                  selected={this.state.donateDisposeDate}
                                />             
                            
              <br/>         
          <label htmlFor="donateDisposeNote" className='text-primary'><b>Note:</b></label>
                        <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="donateDisposeNote"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.donateDisposeNote}
                                          />
            <br/>
            <label htmlFor="returnToStaffName" className='text-primary'><b>Employee Name:</b></label>
                        <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="returnToStaffName"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.returnToStaffName}
                                          />
            <br/>
           
            


        </div>
        <button
          disabled={this.state.disabled}
          className="btn btn-success"
          onClick={() => {this.batchUpdateDontateDisposed()}}>
              Run Batch Update
        </button>
  </Modal>  
      )


  }

renderLargeImage=()=>{

  return(

 
      <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
           <ReactImageMagnify  style={{width:700, height:600}} enlargedImagePosition='over' {...{
                                    smallImage: {
                                        alt: this.state.shortDescription,
                                        isFluidWidth: false,
                                        src: this.state.selectedImageUrl,
                                        width:700,
                                        height:600
                                    },
                                    largeImage: {
                                        src: this.state.selectedImageUrl,
                                        width: 1800,
                                        height: 1600
                                    },
                                    isHintEnabled: true,
                                    shouldHideHintAfterFirstActivation: false
                                }} />
        
          <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
      </Modal>

      )
}

 handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  onReturnedDonateDisposeDateChanged= date => this.setState({ donateDisposeDate:date });


  renderSubscriptionFilter=()=>{
    if (auth0Client.getDefaultVenue().venueTypeCd==='A' && this.state.displayVenueSubscriptions){
   return(
        
       
        <Select
        disabled={this.state.disabled}
        type="text"
        onChange={this.handleSubscriptionFilterChange}
        name="selectedSubscriptionFilters"
       
        placeholder=""
        value= {this.state.selectedSubscriptionFilters}
        options = {this.state.venueSubscriptions}
        selected={this.state.selectedSubscriptionFilters}
        isMulti={true}
      > 
     
      </Select>   

     
   )}
   else {
     return (null);
   }


  }

  renderCards=()=>{
    
    //console.log(props.searchProps);

    return(

      
        <div className='d-flex flex-wrap'>
         {this.renderToast()}

          {this.state.filteredItems === null && <p>Loading lostItems...</p>}
          {
            this.state.filteredItems && this.state.filteredItems.map(lostItem => (
              <div key={lostItem.id} className="col-4" style={{width:250, height:350}}>
                
                  <div className="card text-black bg-secondary mb-4">
                    <div className="card-header">
                      <div className='row'>
                            <div className='col-10'> <h6>{lostItem.shortDescription}</h6></div>
                            <div className='col-2 text-right'> <h5>{lostItem.itemNumber}</h5></div>
                        </div>
                     
                    </div>
                    <div className="card-body">
                   

                      <img src={lostItem.url} alt={lostItem.shortDescription} className="img-thumbnail"  style={{width:200, height:200}}/>

                      <p className="card-text">{lostItem.longDescription}</p>
                    </div>
                  </div>
              
              </div>
            ))
          }
        </div>
      )
   
  }
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
  }

 /*getColumns=(venueTypeCd)=>{
   if (venueTypeCd==='A'){
    return airlineColumns;
   }else if (venueTypeCd==='S'){
    return stadiumColumns;
   }else{
     return columns;
   }
 }*/
    itemNumberSort=(a, b, order, dataField) => {
      
      try {
        let aVal =  (a) ? parseInt(a) :0;
        let bVal =  (b) ? parseInt(b) :0;
  
        if (order === 'asc') {
          return bVal - aVal;
        }
        return aVal - bVal; // desc
      } catch (error) {
        return 0;
      }
    

    };



    getColumns=()=>{
      // venueTypeCd: venue.venueTypeCd,  
      //enableWarehouse:venue.enableWarehouse,
      if (this.state.venueTypeCd==='A'){
        return  [
          { dataField: 'itemNumber',classes:'text-primary', filter: this.customTextFilter(), sortFunc:this.itemNumberSort, sort: true, text: '', headerAlign: 'center', filterable:false,  align: 'left', headerStyle: {width:'90px'} },
          { dataField: 'url', text: 'Picture', formatter: imageFormat,headerAlign: 'center', headerStyle: {width:'100px'}  },
          { dataField: 'shortDescription',classes:'text-primary',filter: this.customDescriptionTextFilter(), sort: true,formatter:LostItemFunctions.formatShortAndLongWithBarcode, text: 'Item', style:{cursor: 'pointer'}, filterable:true,  headerAlign: 'center', textAlign: 'left', headerStyle: {width:'300px', cursor: 'pointer', wordBreak: 'break-word', overflowWrap: 'break-word',}},
          { dataField: 'airportCd',sort: true,hidden:false, filter: this.customTextFilter(),classes:'text-primary', text: 'Airport',style:{cursor: 'pointer'},  headerStyle: (colum, colIndex) => {return { width: '130px', textAlign: 'center', cursor: 'pointer' };}},
        
          { dataField: 'locationName',sort: true, filter: this.customAviationLocationTextFilter(),text: 'Found Loc.',formatter:LostItemFunctions.formatAirlineDetails, style:{cursor: 'pointer'}, textAlign: 'left', classes:'text-primary', headerStyle: { width: '280px', cursor: 'pointer', headerAlign: 'center', textAlign: 'center', fontSize: CELL_FONT_SIZE }},
          //{ dataField: 'transfers',sort: true,formatter: formatCurrentLocation, classes:'text-primary', text: 'Cur. Location', headerAlign: 'center', style:{cursor: 'pointer'}, headerStyle: { width: '250px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
         
          { dataField: 'itemState', sort: true,formatter: formatItemStatusCell, text: 'Status',style:{cursor: 'pointer'},headerStyle: {width:'100px', fontSize: CELL_FONT_SIZE},  headerAlign: 'center', textAlign: 'left', cursor: 'pointer'},
       
          { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found On',style:{cursor: 'pointer'}, headerAlign: 'center',   headerStyle: { width: '180px', textAlign: 'center', cursor: 'pointer', fontSize: CELL_FONT_SIZE}},
          { dataField: 'age',sort: true, filter: this.customNumberFilter(), classes:'text-primary', text: 'Age',align: 'center', style:{cursor: 'pointer'},  headerStyle: (colum, colIndex) => {return { width: '240px', textAlign: 'center', cursor: 'pointer', fontSize: CELL_FONT_SIZE };}},
          
          { dataField: 'foundByName',sort: true, filter: this.customTextFilter(), text: 'Found By',classes:'text-primary', style:{cursor: 'pointer'}, headerStyle: {width:'180px', cursor: 'pointer'}  },
          
          { dataField: 'returnedDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary', text: 'Returned',style:{cursor: 'pointer'},  headerAlign: 'center',  headerStyle: { width: '120px', cursor: 'pointer', textAlign: 'center', fontSize: CELL_FONT_SIZE }},
          { dataField: 'category',sort: true,filter: this.customTextFilter(), text: 'Category',classes:'text-primary',style:{cursor: 'pointer'}, headerStyle: {width:'180px'}  },
          { dataField: 'keywords',sort: true,hidden:false, filter: this.customTextFilter(), text: 'keywords',  headerAlign: 'center',formatter:LostItemFunctions.formatKeyword,style:{cursor: 'pointer'}, headerStyle: {width: '350px', cursor: 'pointer', textAlign: 'left', fontSize: CELL_FONT_SIZE }},
          { dataField: 'storageLocation',sort: true, text: 'Storage Loc.', classes:'text-primary',headerAlign: 'center',style:{cursor: 'pointer'}, headerStyle: {width: '150px', cursor: 'pointer', textAlign: 'left', fontSize: CELL_FONT_SIZE }},
          { dataField: 'venueId',hidden:true, sort: true, text: 'venueId', headerAlign: 'center', classes:'text-primary' },
          { dataField: 'barCodeValue',hidden:true, sort: true, text: 'barCodeValue', headerAlign: 'center', classes:'text-primary' },
          { dataField: 'longDescription',hidden:true, sort: true, text: 'longDescription', headerAlign: 'center', classes:'text-primary' },
           { dataField: 'flightNumber',sort: true, hidden:true,classes:'text-primary', text: 'Flight#',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center', cursor: 'pointer' };}},
          { dataField: 'seat',sort: true, hidden:true,classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center', cursor: 'pointer' };}},
          { dataField: 'terminal',sort: true, hidden:true,classes:'text-primary', text: 'Terminal',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center', cursor: 'pointer' };}},
          { dataField: 'gate',sort: true, hidden:true, classes:'text-primary', text: 'Gate / Lounge',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center', cursor: 'pointer' };}},
          { dataField: 'ownerName',hidden:true, sort: true, text: 'ownerName', headerAlign: 'center', classes:'text-primary' },
        ]
      }else{
        let hotelColumns = [


          { dataField: 'itemNumber',fixed:true, classes:'text-primary',filter: this.customTextFilter(), sortFunc:this.itemNumberSort, sort: true, text: '#', headerAlign: 'center', filterable:false,  align: 'left', headerStyle: {width:'90px', cursor: 'pointer', position:'sticky', top:0,zIndex:1} },
          { dataField: 'url', text: 'Picture', formatter: imageFormat,headerAlign: 'center', headerStyle: {width:'100px'}  },
          { dataField: 'shortDescription', filter: this.customDescriptionTextFilter(), classes:'text-primary', sort: true,formatter:LostItemFunctions.formatShortAndLongWithBarcode,style:{cursor: 'pointer'}, text: 'Item', filterable:true,  
            headerAlign: 'center', textAlign: 'left', headerStyle: {width:'300px', wordBreak: 'break-word', overflowWrap: 'break-word',},
          
          },

          { dataField: 'locationName',sort: true,filter: this.customTextFilter(), text: 'Found Loc.',  textAlign: 'left', classes:'text-primary', style:{cursor: 'pointer'},headerStyle: {width: '160px', headerAlign: 'center', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
          { dataField: 'itemState', sort: true,formatter: formatItemStatusCell, text: 'Status',style:{cursor: 'pointer'},headerStyle: {width:'100px', fontSize: CELL_FONT_SIZE, cursor: 'pointer'},  headerAlign: 'center', textAlign: 'left'},
          { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found On',headerAlign: 'center',   style:{cursor: 'pointer'},headerStyle: { width: '180px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer'}},
          { dataField: 'age',sort: true,filter: this.customNumberFilter(), classes:'text-primary', text: 'Age',align: 'center',  style:{cursor: 'pointer'}, headerStyle: (colum, colIndex) => {return { width: '200px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' };}},
           
          { dataField: 'foundByName',sort: true,filter: this.customTextFilter(), text: 'Found By',classes:'text-primary',style:{cursor: 'pointer'}, headerStyle: {width:'180px'}  },
          { dataField: 'contactedDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary', text: 'Contacted',headerAlign: 'center', style:{cursor: 'pointer'},  headerStyle: { width: '140px', textAlign: 'center', fontSize: CELL_FONT_SIZE , cursor: 'pointer'}},
        
          { dataField: 'returnedDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary', text: 'Returned', headerAlign: 'center', style:{cursor: 'pointer'}, headerStyle: { width: '120px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
          { dataField: 'category',sort: true,filter: this.customTextFilter(), text: 'Category',classes:'text-primary',style:{cursor: 'pointer'}, headerStyle: {width:'180px'}  },
  
          { dataField: 'keywords',sort: true,filter: this.customTextFilter(),hidden:false, text: 'keywords',  headerAlign: 'center',formatter:LostItemFunctions.formatKeyword,style:{cursor: 'pointer'}, headerStyle: {width: '350px', textAlign: 'left', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
          { dataField: 'storageLocation',sort: true, text: 'Storage Loc.', classes:'text-primary',headerAlign: 'center',style:{cursor: 'pointer'}, headerStyle: {width: '150px', textAlign: 'left', fontSize: CELL_FONT_SIZE , cursor: 'pointer'}},
          { dataField: 'venueId',hidden:true, sort: true, text: 'venueId', headerAlign: 'center', classes:'text-primary' },
          { dataField: 'barCodeValue',hidden:true, sort: true, text: 'barCodeValue', headerAlign: 'center', classes:'text-primary' },
          { dataField: 'longDescription',hidden:true, sort: true, text: 'longDescription', headerAlign: 'center', classes:'text-primary' },
          { dataField: 'ownerName',hidden:true, sort: true, text: 'ownerName', headerAlign: 'center', classes:'text-primary' },
        ];
        if (this.state.itemStateFilter==='R'){
          hotelColumns.push(
            { dataField: 'isReturnedToStaff',sort: true, classes:'text-primary',filter: this.customTextBooleanFilter(), formatter:(cell, row)=>{if (cell) {return 'yes'}}, text: 'Returned To Staff', headerAlign: 'center', style:{cursor: 'pointer'}, headerStyle: { width: '150px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
            { dataField: 'returnedToStaffName',sort: true, classes:'text-primary',filter: this.customTextFilter(),  text: 'Staff Name', headerAlign: 'center', style:{cursor: 'pointer'}, headerStyle: { width: '150px', textAlign: 'center', fontSize: CELL_FONT_SIZE, cursor: 'pointer' }},
 
            )
        }
        return hotelColumns;

      }
     
     
    }

  customNumberFilter=()=>{
    if (this.state.useColumnFilters){
    return(
      numberFilter(
        {
          delay: 600, // default is 500ms
          style: {
            backgroundColor: 'white',
            width:'250px'
          },
          withoutEmptyComparatorOption: true,
          //comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
          className: 'custom-numberfilter-class',
          comparatorClassName: 'form-control form-control-sm',
          numberClassName: ' form-control-sm',
          placeholder: '',
          //onClick: e => console.log(e)
        }
      )
    )
      }else{
        return null
      }

  }
  customTextFilter =()=>{
    if (this.state.useColumnFilters){
      return(
        textFilter(
          {
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white'
            },
            className: 'form-control form-control-sm',
            placeholder: '',
           // onClick: e => console.log(e)
          }
        )
      )
    } else{
      return null;
    }   
   
  }

  customTextBooleanFilter=()=>{
    if (this.state.useColumnFilters){
      return(
        textFilter(
          {
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white'
            },
            className: 'form-control form-control-sm',
            placeholder: '',
           // onClick: e => console.log(e)
           onFilter: (filterVal, data) => {
                      if (filterVal && (filterVal.toUpperCase()==='YES' || filterVal.toUpperCase()==='NO')) {
                        return data.filter(lostItem => {
                          if (lostItem.isReturnedToStaff && filterVal.toUpperCase()==='YES'){
                            return true;
                          }
                          if (lostItem.isReturnedToStaff===false && filterVal.toUpperCase()==='NO'){
                            return true;
                          }
                        })
                      }else{
                        return data;
                      }
                    }
          }
        )
      )
    } else{
      return null;
    }   
  }



  customDescriptionTextFilter=()=>{
    
    if (this.state.useColumnFilters){
      return(
        textFilter(
          {
            type: FILTER_TYPES.NUMBER, 
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white'
            },
            className: 'form-control form-control-sm',
            placeholder: 'Enter filter',
            onFilter: (filterVal, data) => {
              if (filterVal) {
                filterVal =filterVal.trim();
                let filters = filterVal.split(' ');
              
                
                return data.filter(lostItem => {
                  let matchScore = 0;
                  let connicle =  (lostItem.shortDescription) ? lostItem.shortDescription.toLowerCase() : '';
                  connicle += (lostItem.longDescription) ? " " + lostItem.longDescription.toLowerCase() : '';
                  connicle += (lostItem.ownerName) ? " " + lostItem.ownerName.toLowerCase() : '';
                  for (var i=0; i<filters.length; i++){
                    if (connicle.includes(filters[i].toLowerCase())) {matchScore +=1}
                  }
                  if (matchScore===filters.length){
                    return true
                  }
                     
                  }
              
                  );
              }else{
                return data;
              }
             
            }
           // onClick: e => console.log(e)
          }
        )
      )
    }else{
      return null;
    }
   

    
  }



  customAviationLocationTextFilter=()=>{
    if (this.state.useColumnFilters){
      return(
        textFilter(
          {
            type: FILTER_TYPES.NUMBER, 
            delay: 600, // default is 500ms
            style: {
              backgroundColor: 'white'
            },
            className: 'form-control form-control-sm',
            placeholder: 'Enter filter',
            onFilter: (filterVal, data) => {
              if (filterVal) {
                filterVal =filterVal.trim();
                let filters = filterVal.split(' ');
              
                
                return data.filter(lostItem => {
                  let matchScore = 0;
                  let connicle =  (lostItem.locationName) ? lostItem.locationName.toLowerCase() : '';
                  connicle += (lostItem.flightNumber) ? " " + lostItem.flightNumber.toLowerCase() : '';
                  connicle += (lostItem.gate) ? " " + lostItem.gate.toLowerCase() : '';
                  connicle += (lostItem.terminal) ? " " + lostItem.terminal.toLowerCase() : '';
                  connicle += (lostItem.seat) ? " " + lostItem.seat.toLowerCase() : '';
                  connicle += (lostItem.ownerName) ? " " + lostItem.ownerName.toLowerCase() : '';
                  for (var i=0; i<filters.length; i++){
                    if (connicle.includes(filters[i].toLowerCase())) {matchScore +=1}
                  }
                  if (matchScore===filters.length){
                    return true
                  }
                     
                  }
              
                  );
              }else{
                return data;
              }
             
            }
           // onClick: e => console.log(e)
          }
        )
      )
    }else{
      return null
    }
   

    
  }

  renderGrid=()=>{

    
    

    return (

      <div >
       
       
       {this.renderToast()}
       {this.state.filteredItems === null && <p>Loading lostItems...</p>}
        <ToolkitProvider 
          bootstrap4
          keyField='id' 
          data={ this.state.filteredItems } 
          columns={ this.getColumns(this.state.venueTypeCd) } 
          
          defaultSorted={defaultSorted}
          search={ {
            searchFormatted: false
          } } 
       
        >
          {
    props => (
      <div>
       
        
       
        <div className='row '>
      <div className='col-2 text-left' >
           <button  className="btn btn-success btn-sm " disabled={auth0Client.lfReadOnly===true}  id="optArchive" onClick={this.createNew} >Add Item </button>
      </div>

     
       
          <div className='col-2 text-center' >
            <div className="form-group" role="group">
            {
                  // (!this.state.useColumnFilters) && <SearchBar placeholder='Filter' { ...props.searchProps } />
            }
            <SearchBar placeholder='Filter All Columns' { ...props.searchProps } />
            </div>
          </div>
         
      
      <div className='col-2 text-right' >
            {this.renderCheckInLocationsFilter()}
             
      </div>
     
      <div className='col-6 text-right' >
  
      {this.renderButtonFilterGroup()}
                 
                  <select className='custom-select alert-success' style={{width:'400px'}} disabled={(this.state.actionButtonDisabled || auth0Client.lfReadOnly===true)}  name='action' onChange={this.handleAction} >
                      <option value="">Select Action ({this.state.checkedCount + ' selected)'}</option>
                      <option value="A">Archive Selected Items... </option>
                      <option value="B">Batch Print Inventory Labels... </option>
                     {(this.state.enableWarehouse) ? ( <option value="CHK">Check-In Items...</option>) :   (null)}
                      <option value="T">Dispose Selected Items...</option>
                      <option value="D">Donate Selected Items...</option>
                      <option value="Q">Move Selected Items Back To Inventory...</option>
                      <option value="R">Return Selected to Staff...</option>
                      {(this.state.enableWarehouse && false) ? ( <option value="TRN">Transfer Items...</option>) :   (null)}
                    </select>
                  
                    <button className="btn btn-primary float-right" id="optArchive" onClick={this.loadLostItems} >{this.state.refreshButtonText}</button>
             
            
            
     </div>
       

       
    </div>

      {this.renderBoostrapTable(props)}
       
       
      </div>
    )
  }</ToolkitProvider>

      </div>


    )

    
  }



renderBoostrapTable=(props)=>{

  return (
    
    <BootstrapTable
    className="table-sm"
    ref={this.tableRef}
    wrapperClasses="table-responsive"
    filter={ filterFactory({afterFilter}) }  
     striped
     hover
     condensed
     rowEvents={this.rowEvents}
    
     selectRow={ { 
       mode: 'checkbox', 
       clickToSelect: true, 
       selected:this.state.selectedRows,
       
       selectColumnStyle: (props) => {
         if (props.checked) {
           console.log('checked');
           return {
             backgroundColor: 'yellow'
           };
         }
         return {
           backgroundColor: 'pink'
         };
       },
       onSelect: (row, isSelect, rowIndex, e) => {
         if (e.target.tagName.toLowerCase() === 'img'){
           //console.log('onSelect');
           e.stopPropagation(); //dont check
           this.setState({
             selectedImageUrl : e.target.src,
             displayLargeImageModal:true});
            
           return;
         }

           let index = this.state.selectedRows.indexOf(row.id);  
           if (isSelect){
             if (index===-1) {
               this.state.selectedRows.push(row.id);
             }
           }else { this.state.selectedRows.splice(index, 1) }
        
         this.setState({
           checkedCount:this.state.selectedRows.length,
           actionButtonDisabled:(this.state.selectedRows.length===0)
         })
       },
       onSelectAll: (isSelect, rows, e) => {
         let selectedRowList = this.state.selectedRows;
         selectedRowList.length=0; //cleared
         //this.cleanSelectedCheckboxes();
         if (isSelect){
           // clear and loop and add each
           
           for(var i=0;i<rows.length; i++) { this.state.selectedRows.push(rows[i].id)}
         }else{
           this.setState({selectedRows:[]});
         }
         this.setState({
           checkedCount:this.state.selectedRows.length,
           actionButtonDisabled:(this.state.selectedRows.length===0)
         })
       },
       selectionRenderer: (props) => (
         <input
             style={{width:'20px', height:'20px', alignSelf:'center'}}
             type={props.mode}
             checked={props.checked}
             onChange={()=>{}}
         />

    
         
       )
   
   }
     }
    
     { ...props.baseProps }
     pagination={ paginationFactory(paginationOption) }
   />
      
  )
}

createNew=()=>{
  this.props.history.push('/LostItem/-1');
}

  gridClick=()=>
  {
    this.setState( {showCards:false })
  }

  cardClick=()=>
  {
    this.setState( {showCards:true })
  }

  gridSort=(col)=>{


  }

applyAllFilters=()=>{

    // There are two filters.  One for the itemState and one for the storageLocation
    let checkInLocationFilter = this.state.checkInLocationFilter;
    let itemStateFilter = this.state.itemStateFilter;
    let itemStateFilterTitle =(itemStateFilter==='')? 'ALL' : LostItemFunctions.itemStatusDesc(itemStateFilter);
    //console.log('location Filter:' + checkInLocationFilter + ', stateFilter:' + itemStateFilterTitle)
    // Check for selected Filters
    if (checkInLocationFilter==='' && itemStateFilter===''){
      this.setState({
        filteredItems:this.state.lostItems,
        selectedFilterLabel: itemStateFilterTitle,
        itemStateFilter:itemStateFilter,
      });
      return;
    }
   // console.log('Applying Settings filtered items to state')
    // Apply the item state and checkinLocationFilter filters
    let filteredItems = this.state.lostItems.filter((lostItem) =>{
      if (itemStateFilter && checkInLocationFilter){
          if (lostItem.itemState === itemStateFilter && lostItem.storageLocation===checkInLocationFilter){
              return lostItem;
          }else{
              return null;
          }
      }else{
        if (itemStateFilter){
          if (lostItem.itemState === itemStateFilter){
                return lostItem;
            }else{
                return null;
          }
        }else if(checkInLocationFilter){
          if (lostItem.storageLocation === checkInLocationFilter){
                return lostItem;
            }else{
                return null;
          }
        }else{
          return null;
        }
      }
        
        });
        

        // apple text filter
       // filteredItems= this.applyTextFilter(this.state.filterText,null,this.state.filteredItems);
      
        this.setState({
          filteredItems: filteredItems,
          selectedFilterLabel: itemStateFilterTitle + ' (' + filteredItems.length + ')',
          itemStateFilter:itemStateFilter,
        });
}

/*applyFilter=(filter)=>{



  
  let selectedFilterTitle =(filter==='')? 'ALL' : LostItemFunctions.itemStatusDesc(filter);

  if (filter===''){
    var filteredItems = this.state.lostItems.filter((lostItem) =>{
      return lostItem;
    });
    this.setState({
      filteredItems: filteredItems,
      selectedFilterLabel: selectedFilterTitle,
      itemStateFilter:filter,
    });

  }else{

    filteredItems = this.state.lostItems.filter((lostItem) =>{
      if (lostItem.itemState === filter){
          return lostItem;
        }else{
          return null;
        }
      });
    
      }
      
      this.setState({
        filteredItems: filteredItems,
        selectedFilterLabel: selectedFilterTitle + ' (' + filteredItems.length + ')',
        itemStateFilter:filter,
      });
}
*/
 filterButtonClick=(event)=>{

    // Clean selected Checkboxes
    this.cleanSelectedCheckboxes();
    
    const target = event.target;
    //console.log(target.id);
    target.checked=false;
    var filter = 'A';
    switch(target.id){
      case 'optOther': filter = 'O'; break;
      case 'optDonated': filter = 'D'; break;
      case 'optDisposed': filter = 'T'; break;
      case 'optClaim':filter = 'C'; break;
      case 'optReturned':filter = 'R'; break;
      case 'optQueue':filter = 'Q'; break;
      case 'optAll':filter = ''; break;
      case 'optArchived':filter = 'A'; break;
      default: filter = '';


    }
    this.setState({itemStateFilter:filter}, ()=>{
      this.applyAllFilters();
    })
    // apply the filter to the existing results
    //this.applyFilter(filter);
   
    // remember MY selection for next time!
    if (cookies){
      //console.log('setting user cooke:' + filter);
      cookies.set('initialLostItemFilter', filter, { path: '/' });
    }
    

    return true;
  }


  // Render lost items "Query" uses advanced features for larger data
  renderQueryLayout = () =>{
  return (

    <div className='row'>
    <div className='col-2'>
      {/*<Filters filterChanged ={this.filterChanged} venueType= {this.state.venueTypeCd}/> */}
    </div>

    <div className='col-10'>
    {this.renderGrid()}
    </div>
    <Modal open={this.state.displayDetailModal} onClose={this.onCloseDetailModal} center>
        
        <LostItemDetailViewer lostItem={this.state.lostItem} isModalDisplay={true} />
      </Modal>  
  </div>

  )

 }

 handleAction=(e)=>{
  
  let numChecked = this.state.selectedRows.length;
  if ( numChecked>0){
    let changeCd = e.target.value;
    let confirmMsg= '';
    switch(changeCd){
      case 'A' : confirmMsg = 'Your about to archive ' + numChecked + ' items. Ok to continue?';break;
      case 'D' : confirmMsg = 'Your about to donate ' + numChecked + ' items. Ok to continue?';break;
      case 'T' : confirmMsg = 'Your about to dispose ' + numChecked + ' items. Ok to continue?';break;
      case 'Q' : confirmMsg = 'Your about to move ' + numChecked + ' items back to the inventory. Ok to continue?';break;
      case 'R' : confirmMsg = 'Your about to return ' + numChecked + ' items back to a staff member. Ok to continue?';break;
      case 'B' : confirmMsg = 'Your about to print ' + numChecked + ' inventory labels. Ok to continue?';break;
      default:confirmMsg='';
    }
    this.setState({changeCd:changeCd});
    if (changeCd==='D' || changeCd==='T'){
      this.setState({displayDonateDisposeModal:true});
    }else if (changeCd==='CHK'){
      this.setState({checkInTransferMode:1, displayCheckInTransfer:true});
    }else if (changeCd==='TRN'){
      this.setState({checkInTransferMode:2, displayCheckInTransfer:true});
    }else if (changeCd==='R'){
      this.setState({ displayReturnToStaff:true});
    }else if (changeCd==='B'){
      this.setState({ displayBatchPrintInventoryLabels:true});
    }
    else{
      if (confirmMsg!=='' && window.confirm(confirmMsg)){
        this.batchUpdate(this.state.selectedRows, changeCd);
      }
    }
   
  
  }else{
    alert("Check the items to update using the checkboxes for each row");
  }
 }

batchUpdateDontateDisposed=()=>{

  if (this.state.donateDisposeDate===undefined){
    alert('Please enter a valid date');
    return;
  }
 
  if (this.state.changeCd!==undefined && this.state.changeCd!=='' ){
    this.setState({displayDonateDisposeModal:false});
    this.batchUpdate(this.state.selectedRows, this.state.changeCd);
  }
  
  

}
// batch update
batchUpdate=(ids, newStatusCd)=>{
  //  console.log('loading...' + auth0Client.getIdToken());
  
  if (ids.length<=0){
    alert('no items selected');
  }
  if (newStatusCd==='' || newStatusCd===undefined){
    alert('No status selected for batch update');
  }

  axios.post(SERVER_URL +  '/LostItems/BatchUpdateStatus',{
    ids:ids,
    statusCd:newStatusCd,
    returnToStaffName:this.state.returnToStaffName,
    donateDisposeNote: this.state.donateDisposeNote,
    donateDisposeDate: this.state.donateDisposeDate,
    isGreenflag: this.state.isGreenflag,
    dispositionVendorId:this.state.dispositionVendorId,
    isReturnedToStaff: (newStatusCd==='R')
   }, 
   {
    headers: { 
      'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId': auth0Client.getActiveVenuedId() 
    }
  }).then((res)=>{
    
    if (res.status !== 200) {
      //place your reentry code
      console.log(res);
      ToastStore.error("An error occured. Please try again :" + res.body);
     
     }else{
      ToastStore.success('Lost Items Saved Successfully!');
      this.setState({donateDisposeNote:'', donateDisposeDate:undefined, displayReturnToStaff:false, displayDonateDisposeModal:false,displayCheckInTransfer:false});
      this.loadLostItems();
     }


    // reload
     

    }).catch((e)=>{ 
      //console.log("error " + e)
      ToastStore.error("An error occured. " + e.message);
    });

}

renderCheckInLocationsFilter=()=>{

  if (auth0Client.getDefaultVenue().enableWarehouse){
   return(
    <div>
       
            <select
            disabled={this.state.disabled}
            type="text"
            onChange={this.handleInputStorageChange}  //important! 
            name="checkInLocationFilter"
            className="custom-select"
            placeholder="Check-In Location Filter"
            value= {this.state.checkInLocationFilter}
          > 
        
           <option key='' value=''>All Check-In Locations</option>
                {this.state.checkInLocations.map(item => (
                  <option key={item._id} value={item.name} id={item._id}>
                    {item.name + ' (' + item.description + ')'}
                  </option>
                ))}
        </select>   
    </div>
    
   )
  }
}

renderButtonFilterGroup=()=>{
  return(
      <div className="btn-group" role="group" >
        <button type="button" className="btn btn-info">Selected Filter:</button>
        <div className="btn-group" role="group">
          <button id="btnGroupDrop1" type="button" className="btn btn-info dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.selectedFilterLabel}</button>
          <div className="dropdown-menu" aria-labelledby="btnGroupDrop1" >Seleted A Filter
             
               <a className="dropdown-item" href="#/" id="optAll" onClick={this.filterButtonClick}>All ({this.state.allCount})</a>
               <a className="dropdown-item" href="#/" id="optArchived" onClick={this.filterButtonClick}>Archived ({this.state.otherCount})</a>
               <a className="dropdown-item" href="#/" id="optClaim" onClick={this.filterButtonClick}>Claimed ({this.state.claimCount})</a>
               <a className="dropdown-item" href="#/" id="optDisposed" onClick={this.filterButtonClick}>Disposed ({this.state.dispossedCount})</a>
               <a className="dropdown-item" href="#/" id="optDonated" onClick={this.filterButtonClick}>Donated ({this.state.donatedCount})</a>
               <a className="dropdown-item" href="#/" id="optReturned" onClick={this.filterButtonClick}>Returned ({this.state.returnCount})</a>
               <a className="dropdown-item" href="#/" id="optQueue" onClick={this.filterButtonClick}>Unclaimed ({this.state.queueCount})</a>

          </div>
        </div>
      </div>


  )
}


switchView=(viewType)=>{
  
    this.setState({
      displayViewType : viewType
    });
    cookies.set('displayViewType', viewType);
  console.log('switching view to ' + viewType);
}
 // Standard is the standard layout without any of the additional query features
/*
  <div className='col-6 text-right'>
      View:
   
    <button className="btn btn-light btn-sm float-right" id="vwPictures" onClick={()=>this.switchView(0)} >Grid</button>
    <button className="btn btn-dark btn-sm float-right" id="vwList" onClick={()=>this.switchView(1)} >Images</button>

    </div>
     <Toggle id='expensive' labelRight="Card View" checked={this.state.showCards} onToggle={value => this.setState({showCards:value}, ()=>{ 
             if (cookies){
              //console.log('setting user cooke:' + filter);
              cookies.set('showCards', this.state.showCards);
            }
          })} /> 
*/
renderStandardLayout = ()=>{
  return (


    <div >
    <div className='row'>
      <div className='col-6'>
            <h4>FOUND ITEM INVENTORY</h4>
    </div>
    <div className='col-6 text-right'>
         
            <ViewToggle style={{height:50, width:50}} initialMode={this.state.displayViewType} onChange={this.switchView}  />

         
          
          <Toggle id='expensive' labelRight="Column Filters" checked={this.state.useColumnFilters} onToggle={value => this.setState({useColumnFilters:value}, ()=>{ 
             if (cookies){
              //console.log('setting user cooke:' + filter);
              cookies.set('useColumnFilters', this.state.useColumnFilters);
            }
          })} /> 
    </div>
   

    
     
      </div>

    
    

     
    <hr />
   


      {
        //(this.state.showCards) ? this.renderCards(): this.renderGrid()
      this.renderGrid()

        }
      <Modal open={this.state.displayDetailModal} onClose={this.onCloseDetailModal} center>
      
      <LostItemDetailViewer lostItem={this.state.lostItem} isModalDisplay={true} />
    </Modal>  
    
     
    </div>



  )
}

handleFilter=(event) =>{
  const target = event.target;
  const value = target.type === 'checkbox' ? target.checked : target.value;
 

 this.setState({
     filterText: value
 })

}

filterKeyPress=(event)=>{
  if (event.key === 'Enter') {
    this.applyAllFilters();
   
  }
}

applyTextFilter=(filterText, SearchInKey, itemsToFilter)=>{
  if (filterText){
    // if the previous filter wiped out all the filter results, then reapply the filters
    //console.log(filterText)
    let columns =  this.getColumns();
    let fields = [];
    for (var i =0; i < columns.length;  i++){fields.push(columns[i].dataField)};
    let searchTokens = filterText.trim().split(' ');
    
    //console.log('Search Tokens:' + searchTokens);
    if (!this.state.filteredItems){return;}
    //console.log("filtering");
    let filterResults = itemsToFilter.filter((lostItem) =>{
      for (var f=0; f < fields.length; f++){
        if (lostItem.hasOwnProperty(fields[f])){
          if (lostItem[fields[f]] && typeof(lostItem[fields[f]]==='String')){
            //console.log(fields[f]);
           
            //if (lostItem[fields[f]].toString().toLowerCase().includes(filterText.toLowerCase())){
            //    return true;
           // }
           let matches = [];
           if (searchTokens.length > 1){
              for (var t=0; t<searchTokens.length; t++){
                if (lostItem[fields[f]].toString().toLowerCase().includes(searchTokens[t].toLowerCase())){
                  matches.push(1)
                }
              };
              //console.log('Checking multiple tokens')
              if  (matches.length === searchTokens.length){
                return true;
              }
           }else{
              if (lostItem[fields[f]].toString().toLowerCase().includes(filterText.trim().toLowerCase())){
                return true;
           }
           }
          }
          
        }
      }  
     
  
    });
  
     return filterResults
  
  }else{
    if (filterText==='') { return itemsToFilter;};  // go back to what ever was selected prior to text filter
  }
 
}

renderGridLayout=()=>{
  return(
    this.renderStandardLayout()
  )
}

handleSearchChange = (e) => {
  let searchText = e.target.value;
  if (searchText!==''){
    let lostItems = this.state.filteredItems.filter((lostItem) =>{
      if (lostItem.shortDescription && lostItem.longDescription && (lostItem.shortDescription.toLowerCase().includes(searchText.toLowerCase()) || lostItem.longDescription.toLowerCase().includes(searchText.toLowerCase()))){
        return true;
      }
      //if (lostItem.shortDescription && lostItem.shortDescription.toLowerCase().includes(searchText.toLowerCase())){
      //  return true;
      //}
    });
    this.setState({filteredItems:lostItems});
  }else{
    //this.setState({filteredItems:this.state.lostItems});
    this.applyAllFilters();
  }

  
};

renderGalleryLayout=()=>{
  return(
    <div >
      <div className='row'>
        <div className='col-6'>
              <h4>FOUND ITEM INVENTORY</h4>
       </div>
      </div>
    <div className='row'>
      <div className='col-2 text-left' >
            <button  className="btn btn-success btn-sm " disabled={auth0Client.lfReadOnly===true}  id="optArchive" onClick={this.createNew} >Add Item </button>
        </div>
        <div className='col-4'>
          <div className="form-group" role="group">
          {
                // (!this.state.useColumnFilters) && <SearchBar placeholder='Filter' { ...props.searchProps } />
          }
          <input
              type="text"
              placeholder="Search Title and Description..."
              className='form-control'
              onChange={this.handleSearchChange}
            />
          </div>
        </div>

        <div className='col text-right'>
              <ViewToggle style={{height:50, width:50}} initialMode={this.state.displayViewType} onChange={this.switchView}  />
        </div>
        <div className='col-3 text-right'>
            {this.renderButtonFilterGroup()}
        </div>
        <div className='col text-right'>
        <button className="btn btn-primary float-right" id="optArchive" onClick={this.loadLostItems} >{this.state.refreshButtonText}</button>
 
        </div>
       
    </div>
    <hr />
    <GalleryView foundItems={this.state.filteredItems} showMagCallBack={(url)=>{this.setState({
             selectedImageUrl : url,
             displayLargeImageModal:true});}}
             />
      <Modal open={this.state.displayDetailModal} onClose={this.onCloseDetailModal} center>
      
      <LostItemDetailViewer lostItem={this.state.lostItem} isModalDisplay={true} />
    </Modal>  
    
     
    </div>
   
  )
}
renderDockingLayout=()=>{
  return(
    <DockView foundItems={this.state.filteredItems} showMagCallBack={(url)=>{this.setState({
      selectedImageUrl : url,
      displayLargeImageModal:true});}}/>
  )
}

  renderResults=()=>{
   
      if (this.state.displayViewType==='table'){
        return( this.renderStandardLayout())
      }else if (this.state.displayViewType==='gallery'){
        return( 

          this.renderGalleryLayout()
        )
      }else{
        return( this.renderDockingLayout())
      }
    
  }
  
  render() {
     return(
      <div className="container-fluid">
        {
         // (this.state.displayQueryLayout) ? this.renderQueryLayout() : this.renderStandardLayout()
        }
       {this.renderResults()}

        {this.renderDisposeDonateDetailsModal()}
        {this.renderReturnToStaff()}
        {this.renderCheckInTransfer()}
        {this.renderLargeImage()}
        {this.renderBatchProcessInventoryLabels()}
        </div>
     )
  }
}

export default withRouter(LostItems);